import RetrieveSourceField from './RetrieveSourceField';

/**
 * แสดงรายการ retrieve-source (API/Azure/Google/Facebook) ที่ผ่านเงื่อนไข gating
 * - API: แสดงเสมอ (requiresLoginMethod: false)
 * - Azure/Google/Facebook: แสดงเฉพาะเมื่อผู้ใช้ติ๊กเลือกวิธีเข้าสู่ระบบนั้นไว้แล้ว
 *   (เดิมเช็คจาก loginmethod (Create) หรือ editloginmethod (Edit) — ส่งเข้ามาเป็น loginMethod)
 */
const RetrieveSourceFieldList = ({ sources, loginMethod, retrieve, setRetrieve, primaryColor }) => (
    <>
        {sources
            .filter(
                (source) =>
                    !source.requiresLoginMethod ||
                    (Array.isArray(loginMethod) && loginMethod.find((item) => item.name === source.key))
            )
            .map((source) => (
                <RetrieveSourceField
                    key={source.key}
                    source={source}
                    retrieve={retrieve}
                    setRetrieve={setRetrieve}
                    primaryColor={primaryColor}
                />
            ))}
    </>
);

export default RetrieveSourceFieldList;